import styled from 'styled-components';
import { smallOnly } from '/imports/ui/stylesheets/styled-components/breakpoints';
import Button from '/imports/ui/components/common/button/component';
import {
  colorPrimary,
  colorWhite,
  colorGrayDark,
  colorGrayLighter,
  colorBlue,
} from '/imports/ui/stylesheets/styled-components/palette';
import {
  borderRadius,
} from '/imports/ui/stylesheets/styled-components/general';

const LeaveButton = styled(Button)`
  ${({ state }) => state === 'open' && `
    @media ${smallOnly} {
      display: none;
    }
  `}

  ${({ state }) => state === 'closed' && `
  @media ${smallOnly} {
    margin-left: 0;
    margin-right: 0;
    padding: .5rem .6rem;
  }
`}

  ${({ state, isMobile }) => state === 'closed' && !isMobile && `
    ${'' /* margin-left: 1.0rem; */}
    margin-left:0.25rem;
    margin-right: 0.5rem;
  `}

  ${({ state }) => state === 'closed' && `
    border-radius: 1.1rem;
    font-size: 1rem;
    line-height: 1.1rem;
    font-weight: 400;
    z-index: 3;
  `}
`;

const SaveExitButton = styled.button`
  background-color: ${colorBlue};
  color: ${colorWhite};
  border: none;
  border-radius: 4px;
  padding: 0.3rem .2rem;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 0.5rem;
  min-width: 90px;

  &:disabled {
    background-color: ${colorGrayLighter};
    color: ${colorGrayDark};
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;


const ButtonText = styled.span`
  font-weight: 600;
`;

export default {
  LeaveButton,
  SaveExitButton,
  ButtonContent,
  ButtonText,
};
